
import React, { useEffect, useRef, useState } from 'react'
import isNull from '../../../utils/NullChecking';
import CustomUseRef from '../DropDown/CustomUseRef';

const CustomTimePicker = (props) => {

    let { SearchParam, setSearchParam, name, className, initialValue, handleOnChange , isReadOnly} = { ...props }

    let hoursArray = Array?.from({ length: 12 }, (_, i) => (String(i + 1).padStart(2, '0')));
    const infiniteHours = hoursArray.concat(hoursArray, hoursArray);

    let minutesArray = Array?.from({ length: 60 }, (_, i) => (String(i).padStart(2, '0')));
    const infiniteMinutes = minutesArray.concat(minutesArray, minutesArray);

    const [selectedHours, setSelectedHours] = useState('01');
    const [selectedMinutes, setSelectedMinutes] = useState('00');
    const [timeFormat, setTimeFormat] = useState('AM');
    const [selectedTime, setSelectedTime] = useState('');
    const [isOpenDropdown, setIsOpenDropdown] = useState(false);
    const [isPropsOnChange, setIsPropsOnChange] = useState(false);
    ///// on key press selection
    const [selectedHourIndex, setSelectedHourIndex] = useState(0);
    const [selectedMinuteIndex, setSelectedMinuteIndex] = useState(0);
    const [selectedAmPmIndex, setSelectedAmPmIndex] = useState(0);
    const [activeSection, setActiveSection] = useState("hours"); // Track active section

    const hourRef = useRef(null);
    const minuteRef = useRef(null);
    const dropdownRef = useRef(null);

    const handleOpenDD = (e) => {
        if (!isReadOnly) {
            // e.stopPropagation();
            setTimeout(() => {
                setIsOpenDropdown(true);
            }, 0);
            // dropdownRef.current?.focus();
            setActiveSection("hours"); // Star
            // scrollToSelected(selectedHours, infiniteHours, hourRef);
            // scrollToSelected(selectedMinutes, infiniteMinutes, minuteRef);
        }

    }

    const handleOnCloseDD = () => {
        setIsOpenDropdown(false);
        setActiveSection("hours");
    }

    const handleChangeTime = (value, valueType) => {
        let modal = { ...SearchParam };

        let hours = selectedHours;
        let minutes = selectedMinutes;
        let format = timeFormat;

        if (valueType === "hours") {
            hours = value;
            setSelectedHours(value);
            setActiveSection("hours");
        } else if (valueType === "minutes") {
            minutes = value;
            setSelectedMinutes(value);
            setActiveSection("minutes");
        }
        else if (valueType === "formate") {
            format = value;
            setTimeFormat(value);
            setActiveSection("amPm");
        }
        let formattedTime = `${hours}:${minutes} ${format}`
        modal[name] = name;
        handleOnChange({ target: { name: name, value: formattedTime } })
        // setSearchParam(modal);
        setSelectedTime(formattedTime);
    }

    // Handles Arrow Up/Down & Tab navigation
    // const handleKeyDown = (e) => {

    //         e.preventDefault(); // Prevent default only for Tab key

    //     if (activeSection === "hours") {
    //         if (e.key === "ArrowUp") {
    //             setSelectedHours((prev) => (parseInt(prev) > 0 ? String(parseInt(prev) - 1).padStart(2, "0") : '11'));
    //         } else if (e.key === "ArrowDown") { 
    //             setSelectedHours((prev) => (parseInt(prev) < 11 ? String(parseInt(prev) + 1).padStart(2, "0") : '00'));
    //         } else if (e.key === "Tab") {
    //             setActiveSection("minutes");        
    //         }
    //         scrollToSelected(selectedHours, infiniteHours, hourRef);

    //     } else if (activeSection === "minutes") {
    //         if (e.key === "ArrowUp") {
    //             setSelectedMinutes((prev) => (parseInt(prev) > 0 ? String(parseInt(prev) - 1).padStart(2, "0") : '59'));
    //             // setSelectedMinutes((prev) => (prev > 0 ? prev - 1 : minutesArray.length - 1));
    //         } else if (e.key === "ArrowDown") {
    //             // setSelectedMinutes((prev) => (prev < '00' ? String(parseInt(prev) - 1).padStart(2, "0") : '59'));
    //             setSelectedMinutes((prev) => (parseInt(prev) < 59 ? String(parseInt(prev) + 1).padStart(2, "0") : '00'));
    //             // setSelectedMinuteIndex((prev) => (prev < '59' ? String(parseInt(prev) + 1).padStart(2, "0") : '00'));
    //         } else if (e.key === "Tab") {
    //             setActiveSection("amPm");
    //         }
    //         scrollToSelected(selectedMinutes, infiniteMinutes, minuteRef);
    //     } else if (activeSection === "amPm") {
    //         if (e.key === "ArrowUp" || e.key === "ArrowDown") {
    //             setTimeFormat((prev) => (prev === 'AM' ? 'PM' : 'AM'));
    //         } else if (e.key === "Tab") {
    //             setActiveSection("hours"); // Loop back to hours
    //         }
    //     }
    // };
    const handleKeyDown = (e) => {
        e.preventDefault(); // Prevent default scrolling

        let modal = { ...SearchParam };
        if (activeSection === "hours") {
            let selectedValue = selectedHours;
            if (e.key === "ArrowUp") {
                setSelectedHours((prev) => {
                    let newVal = prev === "01" ? "12" : String(parseInt(prev, 10) - 1).padStart(2, "0");
                    selectedValue = newVal;
                    // ScrollToSelected(newVal, infiniteHours, hourRef);
                    scrollToSelected(newVal, infiniteHours, hourRef);
                    let formattedTime = `${selectedValue}:${selectedMinutes} ${timeFormat}`
                    modal[name] = formattedTime;
                    handleOnChange({ target: { name: name, value: formattedTime } })
                    // setSearchParam(modal);
                    setSelectedTime(formattedTime);
                    return newVal;
                });
            } else if (e.key === "ArrowDown") {
                setSelectedHours((prev) => {
                    let newVal = prev === "12" ? "01" : String(parseInt(prev, 10) + 1).padStart(2, "0");
                    let formattedTime = `${newVal}:${selectedMinutes} ${timeFormat}`
                    //bring the selected value into view:
                    // ScrollToSelected(newVal, infiniteHours, hourRef);
                    scrollToSelected(newVal, infiniteHours, hourRef);
                    // setting new value selected to the modal from props:
                    modal[name] = formattedTime;
                    handleOnChange({ target: { name: name, value: formattedTime } })
                    // setSearchParam(modal);
                    // seeting new value to the input field value:
                    setSelectedTime(formattedTime);

                    return newVal;
                });
            } else if (e.key === "Tab") {
                setActiveSection("minutes");
                // scrollToSelected(selectedMinutes, infiniteMinutes, minuteRef);
            }


        }

        else if (activeSection === "minutes") {
            if (e.key === "ArrowUp") {
                setSelectedMinutes((prev) => {
                    let newVal = prev === "00" ? "59" : String(parseInt(prev, 10) - 1).padStart(2, "0");
                    let formattedTime = `${selectedHours}:${newVal} ${timeFormat}`
                    //bring the selected value into view:
                    // ScrollToSelected(newVal, infiniteMinutes, minuteRef);
                    scrollToSelected(newVal, infiniteMinutes, minuteRef);
                    // setting new value selected to the modal from props:
                    modal[name] = formattedTime;
                    handleOnChange({ target: { name: name, value: formattedTime } })
                    // setSearchParam(modal);
                    // seeting new value to the input field value:
                    setSelectedTime(formattedTime);
                    return newVal;
                });
            } else if (e.key === "ArrowDown") {
                setSelectedMinutes((prev) => {
                    let newVal = prev === "59" ? "00" : String(parseInt(prev, 10) + 1).padStart(2, "0");
                    let formattedTime = `${selectedHours}:${newVal} ${timeFormat}`
                    //bring the selected value into view:
                    // ScrollToSelected(newVal, infiniteMinutes, minuteRef);
                    scrollToSelected(newVal, infiniteMinutes, minuteRef);
                    // setting new value selected to the modal from props:
                    modal[name] = formattedTime;
                    handleOnChange({ target: { name: name, value: formattedTime } })
                    // setSearchParam(modal);
                    // seeting new value to the input field value:
                    setSelectedTime(formattedTime);
                    return newVal;
                });
            } else if (e.key === "Tab") {
                setActiveSection("amPm");
            }
        }

        else if (activeSection === "amPm") {
            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                setTimeFormat((prev) => {
                    let newVal = prev === "AM" ? "PM" : "AM";
                    let formattedTime = `${selectedHours}:${selectedMinutes} ${newVal}`
                    // setting new value selected to the modal from props:
                    modal[name] = formattedTime;
                    handleOnChange({ target: { name: name, value: formattedTime } })
                    // setSearchParam(modal);
                    // seeting new value to the input field value:
                    setSelectedTime(formattedTime);
                    return newVal;
                });
            } else if (e.key === "Tab") {
                setActiveSection("hours"); // Loop back to hours
                // scrollToSelected(selectedHours, infiniteHours, hourRef);
            }
        }
    };

    // Handle infinite scrolling behavior
    const handleInfiniteScroll = (ref, list) => {
        if (!ref.current) return;
        const { scrollTop, scrollHeight, clientHeight } = ref.current;

        const itemHeight = 26;
        const totalItems = list.length / 3;

        if (scrollTop + clientHeight >= scrollHeight - itemHeight) {
            ref.current.scrollTop = totalItems * itemHeight;
        }

        if (scrollTop <= 0) {
            ref.current.scrollTop = totalItems * itemHeight;
        }
    };


    const scrollToSelected = (selectedValue, list, ref, forceCenter = false) => {
        if (!ref.current) return;

        const items = Array.from(ref.current.children);
        const selectedElements = items.filter(
            (el) => el.textContent.trim() === selectedValue.toString()
        );

        if (selectedElements.length > 1) {
            const middleIndex = Math.floor(selectedElements.length / 2);

            if (forceCenter) {
                // ✅ When opening the dropdown, move selected item to middle
                ref.current.scrollTop = (selectedElements[middleIndex].offsetTop - 5);
            } else {
                // ✅ When using arrow keys, scroll smoothly
                selectedElements[middleIndex].scrollIntoView({
                    // behavior: "smooth",
                    block: "nearest",
                    inline: "nearest",
                });
            }
        } else if (selectedElements.length === 1) {
            if (forceCenter) {
                ref.current.scrollTop = selectedElements[0].offsetTop - 5;
            } else {
                selectedElements[0].scrollIntoView({
                    // behavior: "smooth",
                    block: "nearest",
                    inline: "nearest",
                });
            }
        }
    };


    useEffect(() => {

        if (!isNull(initialValue)) {
            let initalSearchValue = String(initialValue);
            let requiredChecksArray = [' ', ":"];
            let optionalChecksArray = ['AM', "PM"];

            const isValid = requiredChecksArray.every(sub => initalSearchValue.includes(sub)) &&
                optionalChecksArray.some(sub => initalSearchValue.includes(sub));

            if (!isNull(initalSearchValue) && isValid) {

                let timeArray = initalSearchValue?.split(" ");
                let timeString = timeArray[0];
                let timeFormat = timeArray[1];

                let minutesHoursArray = timeString.split(":");

                let initialHours = minutesHoursArray[0];
                let initialMinutes = minutesHoursArray[1];

                let formatedTime = `${initialHours}:${initialMinutes} ${timeFormat}`

                setSelectedHours(initialHours);
                setSelectedMinutes(initialMinutes);
                setTimeFormat(timeFormat);

                setSelectedTime(formatedTime);

            } else {
                console.log("invalid time string");
            }
        } else {
            let currentDate = new Date();
            let hours = currentDate.getHours();
            let minutes = currentDate.getMinutes().toString().padStart(2, '0');
            let amPm = hours >= 12 ? 'PM' : 'AM';
            hours = (hours % 12 || 12).toString().padStart(2, '0');

            let formatedTime = `${hours}:${minutes} ${amPm}`

            setSelectedHours(hours);
            setSelectedMinutes(minutes);
            setTimeFormat(amPm);

            setSelectedTime(formatedTime);
        }

        if (handleOnChange) {
            setIsPropsOnChange(true);
        } else {
            setIsPropsOnChange(true);
        }

    }, [initialValue, isOpenDropdown])

    ////scroll to selected hours and minutes///////
    useEffect(() => {
        if (isOpenDropdown) {
            scrollToSelected(selectedHours, infiniteHours, hourRef, true);
            scrollToSelected(selectedMinutes, infiniteMinutes, minuteRef, true);
            dropdownRef.current?.focus();
        }
    }, [isOpenDropdown])

    useEffect(() => {

    }, [])

    return (
        <div className={`ar_time-control ${className}`} >
            {/* <input name="time" id="time" type="text" readOnly value={selectedTime} onFocus={() => setIsOpenDropdown(true)} /> */}
            <div className="input mb-0" onClick={(e) => handleOpenDD(e)}>
                <input
                    type="text"
                    className="form-control ar-icon cursor-pointer"
                    name={name}
                    id="time"
                    placeholder="hh:mm"
                    readOnly
                    value={isPropsOnChange ? initialValue : selectedTime}
                // onFocus={(e) => handleOpenDD(e)}
                />
            </div>
            <CustomUseRef onClose={() => handleOnCloseDD()} IsActivePtPayments={isOpenDropdown}>
                <div className="ar_time-control-list d-flex gap-15" onKeyDown={handleKeyDown} ref={dropdownRef} tabIndex={0} > {/* // 👈 tabIndex={0} Make it focusable */}
                    <div className="d-flex flex-column gap-5 time_list" ref={hourRef} onScroll={(e) => handleInfiniteScroll(hourRef, infiniteHours)}>

                        {infiniteHours?.map((item, index) => {
                            return <p key={index} className={`time_box text ${selectedHours === item ? "active" : ""} ${selectedHours === item && activeSection === 'hours' ? 'border border-dark' : ''}`} onClick={() => handleChangeTime(item, 'hours')}>{item}</p>
                        })

                        }
                    </div>

                    <div className="d-flex flex-column gap-5 time_list" ref={minuteRef} onScroll={(e) => handleInfiniteScroll(minuteRef, infiniteMinutes)}>
                        {infiniteMinutes?.map((item, index) => {
                            return (<p key={index} className={`time_box text ${selectedMinutes === item ? "active" : ""} ${selectedMinutes === item && activeSection === 'minutes' ? 'border border-dark' : ''}`} onClick={() => handleChangeTime(item, 'minutes')} >
                                {item}
                            </p>)
                        })
                        }
                    </div>

                    <div className="d-flex flex-column gap-5 am-pm-list">
                        {['AM', 'PM']?.map((item => (
                            <p className={`time_box text ${timeFormat === item ? "active" : ""} ${timeFormat === item && activeSection === 'amPm' ? 'border border-dark' : ''}`} onClick={() => handleChangeTime(item, 'formate')}>{item}</p>
                        )))}
                        {/* <p className="time_box text" >AM</p>
                    <p className="time_box text active">PM</p> */}
                    </div>

                </div>
            </CustomUseRef>
        </div >
    )
}

export default CustomTimePicker
